export default [
  { country: "Afganistán" },
  { country: "Albania" },
  { country: "Alemania" },
  { country: "Andorra" },
  { country: "Angola" },
  { country: "Antigua y Barbuda" },
  { country: "Arabia Saudita" },
  { country: "Argelia" },
  { country: "Argentina" },
  { country: "Armenia" },
  { country: "Australia" },
  { country: "Bélgica" },
  { country: "Belice" },
  { country: "Benín" },
  { country: "Bielorrusia" },
  { country: "Birmania" },
  { country: "Bolivia" },
  { country: "Bosnia y Herzegovina" },
  { country: "Botsuana" },
  { country: "Brasil" },
  { country: "Brunéi" },
  { country: "Bulgaria" },
  { country: "Burkina Faso" },
  { country: "Burundi" },
  { country: "Bután" },
  { country: "Cabo Verde" },
  { country: "Camboya" },
  { country: "Camerún" },
  { country: "Canadá" },
  { country: "Catar" },
  { country: "Chad" },
  { country: "Chile" },
  { country: "China" },
  { country: "Chipre" },
  { country: "Ciudad del Vaticano" },
  { country: "Comoras" },
  { country: "Corea del Sur" },
  { country: "Costa de Marfil" },
  { country: " Costa Rica" },
  { country: "Dinamarca" },
  { country: "Dominica" },
  { country: "Ecuador" },
  { country: "Egipto" },
  { country: "El Salvador" },
  { country: "Emiratos Árabes Unidos" },
  { country: "Eritrea" },
  { country: "Eslovaquia" },
  { country: "Eslovenia" },
  { country: "España" },
  { country: "Estados Unidos" },
  { country: "Estonia" },
  { country: "Etiopía" },
  { country: "Filipinas" },
  { country: "Finlandia" },
  { country: "Fiyi" },
  { country: "Francia" },
  { country: "Gabón" },
  { country: "Gambia" },
  { country: "Georgia" },
  { country: "Grecia" },
  { country: "Guatemala" },
  { country: "Guyana" },
  { country: "Guinea" },
  { country: "Haití" },
  { country: "Honduras" },
  { country: "Hungría" },
  { country: "Irán" },
  { country: "Irlanda" },
  { country: "Islandia" },
  { country: "Israel" },
  { country: "Italia" },
  { country: "Jamaica" },
  { country: "Japón" },
  { country: "Jordania" },
  { country: "Kazajistán" },
  { country: "Kenia" },
  { country: "Líbano" },
  { country: "Liberia" },
  { country: "Libia" },
  { country: "Liechtenstein" },
  { country: "Lituania" },
  { country: "Luxemburgo" },
  { country: "Madagascar" },
  { country: "Malasia" },
  { country: "Malaui" },
  { country: "Maldivas" },
  { country: "Malí" },
  { country: "Malta" },
  { country: "Marruecos" },
  { country: "Mauritania" },
  { country: "México" },
  { country: "Micronesia" },
  { country: "Moldavia" },
  { country: "Mónaco" },
  { country: "Mongolia" },
  { country: "Montenegro" },
  { country: "Mozambique" },
  { country: "Namibia" },
  { country: "Nauru" },
  { country: "Nepal" },
  { country: "Nicaragua" },
  { country: "Níger" },
  { country: "Nigeria" },
  { country: "Noruega" },
  { country: "Omán" },
  { country: "Pakistán" },
  { country: "Palaos" },
  { country: "Panamá" },
  { country: "  Papúa Nueva Guinea" },
  { country: "Paraguay" },
  { country: "Perú" },
  { country: "Polonia" },
  { country: "Portugal" },
  { country: "Reino Unido" },
  { country: "Ruanda" },
  { country: "Rumanía" },
  { country: "Rusia" },
  { country: "Samoa" },
  { country: "Senegal" },
  { country: "Singapur" },
  { country: "Siria" },
  { country: "Somalia" },
  { country: "Suecia" },
  { country: "Suiza" },
  { country: "Surinam" },
  { country: "Tailandia" },
  { country: "Tanzania" },
  { country: "Tayikistán" },
  { country: "Togo" },
  { country: "Turquía" },
  { country: "Tuvalu" },
  { country: "Ucrania" },
  { country: "Uganda" },
  { country: "Uruguay" },
  { country: "Uzbekistán" },
  { country: "Vanuatu" },
  { country: "Venezuela" },
  { country: "Vietnam" },
  { country: "Yemen" },
  { country: "Yibuti" },
  { country: "Zambia" },
];
